import { render, staticRenderFns } from "./CreateHotelN.vue?vue&type=template&id=351beaf1"
import script from "./CreateHotelN.vue?vue&type=script&lang=js"
export * from "./CreateHotelN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports